import { useCoreStore } from 'src/stores/core/store';
import { AppCoreEnums } from 'src/core/shared/enums';
import { ResolveParams } from 'src/core/models/routing';
import { IDynamicFilterItem } from 'src/stores/core/models';
import { dynamicFiltersUtils } from 'src/core/utils/dynamic-filters-utils';
import { defaultPagination, FiltersBaseInterface, IFilterItem, Pagination } from '../../../stores/core/models';

export default () => {
  const buildResolveParamsFiltersUsingId = (resolveParams: ResolveParams) => buildResolveParamsFilters(resolveParams, 'id');
  const buildResolveParamsFiltersUsingId2 = (resolveParams: ResolveParams) => buildResolveParamsFilters(resolveParams, 'id2');
  const buildResolveParamsFiltersUsingId3 = (resolveParams: ResolveParams) => buildResolveParamsFilters(resolveParams, 'id3');

  const buildResolveParamsFilters = (
    resolveParams: ResolveParams,
    idRouteParam: 'id' | 'id2' | 'id3' | undefined = undefined,
  ) => {
    const store = useCoreStore();

    let storePagination: Pagination = defaultPagination;
    let storeFilters: IFilterItem[] = [];
    let storeSearch: string | undefined;
    let storeDynamicFilters: IDynamicFilterItem[] = [];

    switch (resolveParams.containerType) {
      case AppCoreEnums.ContainerType.CollapsibleTableContainer:
        storePagination = store.collapsibleTableContainerData.pagination;
        storeFilters = store.collapsibleTableContainerData.filters;
        storeSearch = store.collapsibleTableContainerData.searchBy;
        storeDynamicFilters = store.collapsibleTableContainerData.dynamicFilters;
        break;

      case AppCoreEnums.ContainerType.TableContainer:
        storePagination = store.tableContainerData.pagination;
        storeFilters = store.tableContainerData.filters;
        storeSearch = store.tableContainerData.searchBy;
        storeDynamicFilters = store.tableContainerData.dynamicFilters;

        break;

      case AppCoreEnums.ContainerType.TableInnerContainer:
        storePagination = store.tableInnerContainerData.pagination;
        storeFilters = store.tableInnerContainerData.filters;
        storeSearch = store.tableInnerContainerData.searchBy;
        storeDynamicFilters = store.tableInnerContainerData.dynamicFilters;
        break;

      case AppCoreEnums.ContainerType.LogsTableContainer:
        storePagination = store.logsTableContainerPagination;
        storeFilters = store.logsTableContainerFilters;
        storeSearch = store.logsTableContainerSearchBy;
        break;

      case AppCoreEnums.ContainerType.DrawerContainer:
        storePagination = store.drawerContainerData.pagination;
        storeFilters = store.drawerContainerData.filters;
        storeSearch = store.drawerContainerData.searchBy;
        break;

      case AppCoreEnums.ContainerType.CollapsibleContainer:
        storePagination = store.collapsibleContainerData.pagination;
        storeFilters = store.collapsibleContainerData.filters;
        storeSearch = store.collapsibleContainerData.searchBy;
        storeDynamicFilters = store.collapsibleContainerData.dynamicFilters;
        break;

      case AppCoreEnums.ContainerType.ListContainer:
        storePagination = store.listContainerData.pagination;
        storeFilters = store.listContainerData.filters;
        storeSearch = store.listContainerData.searchBy;
        storeDynamicFilters = store.listContainerData.dynamicFilters;
        break;
    }

    storeFilters = storeFilters || [];
    storeSearch = storeSearch || '';
    storeDynamicFilters = storeDynamicFilters || [];

    const searchBy = resolveParams.useStoreData ? storeSearch : '';
    const pagination = resolveParams.pagination || (resolveParams.useStoreData ? storePagination : defaultPagination);
    const filters = resolveParams.useStoreData ? storeFilters : resolveParams.initialFiltersFromUserPreferences || [];
    const dynamicFilters = resolveParams.useStoreData ? storeDynamicFilters : resolveParams.initialDynamicFilters || [];
    const filterItems = [...filters, ...dynamicFiltersUtils.convertDynamicFiltersToFilterItems(dynamicFilters)];

    if (idRouteParam && idRouteParam in resolveParams.params) {
      filterItems.push({
        fieldName: 'Id', //idRouteParam.substring(0, 1).toUpperCase() + idRouteParam.substring(1),
        values: [resolveParams.params[idRouteParam] as string],
        filterType: AppCoreEnums.FilterItemType.Text,
      });
    }

    const filtersBase = <FiltersBaseInterface>{
      filterItems: filterItems,
      searchBy,
      pagination,
      //...resolveParams.params,
    };

    return filtersBase;
  };

  return {
    buildResolveParamsFilters,
    buildResolveParamsFiltersUsingId,
    buildResolveParamsFiltersUsingId2,
    buildResolveParamsFiltersUsingId3,
  };
};
